import { Box, Text } from '@chakra-ui/react';
import { SharedIconArrowLongDown } from '../../icons';
import React, { FunctionComponent } from 'react';

interface StepperPreviousProps {
  currentStep?: number;
  totalSteps?: number;
  title: string;
  handleBackClick: () => void;
  variant?: 'default' | 'horizontal' | 'orange';
}

export const StepperPrevious: FunctionComponent<StepperPreviousProps> = ({
  currentStep,
  totalSteps,
  title,
  handleBackClick,
  variant = 'default'
}) => {
  return (
    <Box onClick={handleBackClick} className={`cursor-pointer`}>
      <Box className={`flex justify-between`}>
        <Box
          className={`flex ${variant === 'horizontal' && 'items-center'} ${
            variant === 'orange' && 'text-orange-500'
          }`}>
          <SharedIconArrowLongDown
            boxSize={6}
            className={`${
              variant === 'default' ? 'rotate-180' : 'rotate-90'
            } mr-4`}></SharedIconArrowLongDown>
          <Text>{title}</Text>
        </Box>
        {currentStep && totalSteps && (
          <Text as={`span`}>
            {currentStep} / {totalSteps}
          </Text>
        )}
      </Box>
      {variant === 'default' && <hr className={`my-4`} />}
    </Box>
  );
};
